var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhotovoltaicOperation({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_3791_7543)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 4,
    width: 24,
    height: 24,
    rx: 4,
    fill: "#E8A000"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6.5,
    y: 4.5,
    width: 23,
    height: 23,
    rx: 3.5,
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.4209 16.6689C23.6252 16.6822 23.8241 16.7428 24.002 16.8457C24.2052 16.9633 24.3743 17.1323 24.4912 17.3359C24.608 17.5394 24.6679 17.7703 24.667 18.0049C24.6661 18.237 24.6043 18.465 24.4883 18.666L24.4893 18.667L23.6973 20.0547L24.6211 22.4248C24.7546 22.7678 24.5842 23.1545 24.2412 23.2881C23.8984 23.4213 23.5116 23.2519 23.3779 22.9092L22.8467 21.5459L22.4199 22.2949L22.4209 22.2959C22.2485 22.61 21.9948 22.8722 21.6865 23.0547C21.4165 23.2145 21.1126 23.3083 20.8008 23.3291L20.667 23.333H12.667L12.4922 23.3213C12.3189 23.2985 12.1514 23.2415 11.999 23.1533C11.7959 23.0356 11.6266 22.8668 11.5098 22.6631C11.3931 22.4594 11.3319 22.2279 11.333 21.9932C11.3343 21.7613 11.3967 21.5337 11.5127 21.333L13.585 17.6963C13.7571 17.3862 14.0084 17.1272 14.3135 16.9463C14.622 16.7635 14.9744 16.6671 15.333 16.667H23.333L23.4209 16.6689ZM12.6709 21.9932L12.667 22H16.0928L16.8526 20.667H13.4268L12.6709 21.9932ZM17.6279 22H20.667C20.7863 22 20.9041 21.9679 21.0069 21.9072C21.1095 21.8464 21.1945 21.7589 21.252 21.6543L21.2569 21.6445L21.8145 20.667H18.3867L17.6279 22ZM15.333 18C15.2136 18.0001 15.0959 18.0319 14.9932 18.0928C14.8904 18.1537 14.8064 18.2419 14.749 18.3467C14.7473 18.3499 14.745 18.3532 14.7432 18.3564L14.1865 19.333H17.6123L18.3721 18H15.333ZM19.1475 19.333H22.5752L23.3311 18.0068L23.334 18H19.9063L19.1475 19.333ZM12 14C12.3682 14 12.667 14.2988 12.667 14.667V16C12.667 16.3682 12.3682 16.667 12 16.667C11.6319 16.6669 11.333 16.3682 11.333 16V14.667C11.333 14.2988 11.6319 14.0001 12 14ZM15.3018 12.6357C15.5621 12.3754 15.9848 12.3754 16.2451 12.6357L17.1846 13.5752C17.4448 13.8356 17.4449 14.2582 17.1846 14.5186C16.9243 14.7784 16.5024 14.7784 16.2422 14.5186L15.3018 13.5781C15.0417 13.3179 15.0418 12.8961 15.3018 12.6357ZM14.667 8.66699C15.035 8.66712 15.3328 8.96504 15.333 9.33301C15.333 10.2171 14.9816 11.0653 14.3565 11.6904C13.7314 12.3153 12.8839 12.667 12 12.667C11.6319 12.6669 11.333 12.3682 11.333 12C11.333 11.6318 11.6319 11.3331 12 11.333C12.5304 11.333 13.039 11.1221 13.4141 10.7471C13.7891 10.372 14 9.86339 14 9.33301C14.0002 8.96497 14.2989 8.66699 14.667 8.66699ZM18.667 8.66699C19.035 8.66712 19.3328 8.96504 19.333 9.33301C19.333 9.70112 19.0351 9.99988 18.667 10H17.333C16.965 9.99977 16.667 9.70106 16.667 9.33301C16.6672 8.96511 16.9651 8.66722 17.333 8.66699H18.667Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_3791_7543",
    x: 0,
    y: 0,
    width: 36,
    height: 36,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3791_7543"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3791_7543",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhotovoltaicOperation);
export default __webpack_public_path__ + "static/media/photovoltaic_operation.8614b7d9fd4e38f26c1c381f45e65e84.svg";
export { ForwardRef as ReactComponent };